export default "__VITE_ASSET__CLdot3G3__"